import { ManagerData } from 'api/types/data';

import { ExecutionPlaceEntity } from '../executionPlaceEntity';
import { FileEntity } from '../fileEntity';

import { OperationOrderEntity } from './operationOrderEntity';
import { OperationStatusType } from './operationStatusType';

export enum OperationType {
  /** Сделка */
  Trade = 'Trade',
}

export enum OperationExecutionMethod {
  /** Прямая сделка */
  Direct = 'Direct',
  /** Открытая сделка */
  Open = 'Open',
}

export interface OperationEntity {
  id: string;

  /** Дата и время создания сделки */
  createdAt: Date;

  versionNumber?: number;

  /** Тип операции */
  type: OperationType;

  /** Статус сделки */
  status: OperationStatusType;

  /** Поручение */
  order: OperationOrderEntity;

  /** Номер сделки */
  number: string;

  /** Дата и время заключения сделки */
  executedAt: Date;

  /** Метод совершения сделки */
  executionMethod: OperationExecutionMethod;

  /** Место заключения сделки */
  executionPlace?: ExecutionPlaceEntity;

  /** Специализированные торги */
  isSpecializedTrade: boolean;

  /** Трейдер */
  trader?: ManagerData;

  /** Наименование контрагента */
  counterpartyName?: string | null;

  /** Количество */
  quantity: number;

  /** Чистая цена за единицу */
  netUnitPrice: string;

  /** Цена за единицу */
  unitPrice?: string | null;

  /** НКД — накопленный купонный доход */
  accruedCouponIncome?: string | null;

  /** Объем сделки */
  volume?: string | null;

  /** Дата расчетов */
  settlementDate: Date;

  /** Курс */
  exchangeRate?: string | null;

  /** Подтверждающие документы */
  confirmationFiles?: FileEntity[];

  /** Дополнительные заметки */
  additionalNotes?: string | null;
}
